module.exports = __webpack_public_path__ + "static/media/alert-triangle-yellow.0969a0be.svg";